"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.getTitle = exports.getBrandName = exports.defaultProps = exports.default = exports.ProductCardHorizontal = void 0;
require("./ProductCardHorizontal.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _conditionalAttributes = require("../../util/conditionalAttributes/conditionalAttributes");
var _ProductCard = _interopRequireDefault(require("../ProductCard/ProductCard"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ProductCardHorizontal component
 *
 * @method
 * @param { ProductCardHorizontalProps} props
 * @returns ProductCardHorizontal
 */

const ProductCardHorizontal = props => {
  const {
    /* palette props */
    style = defaultProps.style,
    // rail or list style

    /* actions */
    externalActionElement,
    // the fully clickable link that goes to the PDP page
    fullyClickableParent,
    // boolean if card can be fully clickable
    externalFooterActionElement,
    // addToBagAction in web-site

    /* image */
    externalMediaElement,
    // image from web-site

    /* productVariant */
    externalSwatchImage,
    // external swatch image
    swatchImage,
    // palette swatch image
    variantTypeDescription,
    // variantLabel in web-site
    variantTypeLabel,
    // variant label coming from web-site

    /* price */
    kitPrice,
    // kit price in web-site
    kitPriceAccessibilityLabel,
    // kit price accessibility in web-site
    listPrice,
    // list price in web-site
    listPriceAccessibilityLabel,
    // list price accessibility in web-site
    originalPriceLabel,
    // original price label in web-site
    priceLabel,
    // price label in web-site
    salePrice,
    // sale price in web-site
    salePriceAccessibilityLabel,
    // sale price accessibility in web-site
    priceMessage,
    // message to display when there is no price
    priceDisabled,
    // sets the disabled state for the price

    /* reviews */
    rating,
    // rating number in web-site
    reviewAccessibilityLabel,
    // review accessibility in web-site
    reviewCount,
    // number of reviews in web-site

    /* text */
    additionalOffersText,
    // second valueTag in web-site
    brandName,
    // brand name in web-site
    htmlTag,
    // htmlTag for productName in web-site
    promoText,
    // first valueTag in web-site
    productName,
    // product name in web-site
    tagMessage,
    // tag coming from web-site

    /* tags */
    tagsTop,
    tagsBottom,
    /* loading state */
    isLoading = defaultProps.isLoading,
    loaderHeightSm,
    loaderHeightMd,
    loaderHeightLg,
    loaderHeightXl
  } = props;
  let newBrandName;
  let newTitle;

  /* ProductCardHorizontal styles */
  const isRailStyle = style === 'rail';
  const isListStyle = style === 'list';

  /* ProductCardHorizontal rail styles */
  const hasElevation = isRailStyle;

  /* ProductCardHorizontal list styles */
  const headerBackgroundColor = isListStyle ? 'background-xsubtle' : undefined;
  const headerPadding = isListStyle ? 'item' : undefined;
  const screenReaderText = brandName + ' ' + productName;
  if (brandName) {
    newBrandName = getBrandName({
      style: style,
      brandName: brandName
    });
  }
  if (brandName && productName) {
    newTitle = getTitle({
      style: style,
      brandName: brandName,
      productName: productName
    });
  }
  const componentClassName = (0, _classnames.default)('pal-c-ProductCardHorizontal', {
    'pal-c-ProductCardHorizontal__hasLink': fullyClickableParent,
    [`pal-c-ProductCardHorizontal__style--${style}`]: style,
    'pal-c-ProductCardHorizontal--loading': isLoading
  });
  const componentContainer = (0, _classnames.default)('pal-c-ProductCardHorizontal__container', {
    'pal-c-ProductCardHorizontal__elevation--medium': isRailStyle
  });
  const componentLoaderStyle = {
    ...(0, _conditionalAttributes.conditionalAttributes)(isLoading ? {
      '--pal-loaderghost-card-height-xl': loaderHeightXl,
      '--pal-loaderghost-card-height-lg': loaderHeightLg,
      '--pal-loaderghost-card-height-md': loaderHeightMd,
      '--pal-loaderghost-card-height-sm': loaderHeightSm
    } : null)
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName,
    style: componentLoaderStyle
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: componentContainer
  }, /*#__PURE__*/_react.default.createElement(_ProductCard.default, {
    brandName: {
      text: newBrandName,
      textColor: 'xsubtle',
      textStyle: 'label'
    },
    contentGap: "sm",
    externalActionElement: externalActionElement,
    externalFooterActionElement: externalFooterActionElement,
    externalMediaElement: externalMediaElement,
    fullyClickableParent: fullyClickableParent,
    headerBackgroundColor: headerBackgroundColor,
    headerPadding: headerPadding,
    isElevated: hasElevation,
    imageAltText: screenReaderText,
    imgGap: "sm",
    imgAlign: "left",
    price: {
      disabled: priceDisabled,
      kitPrice: kitPrice,
      kitPriceAccessibilityLabel: kitPriceAccessibilityLabel,
      listPrice: listPrice,
      listPriceAccessibilityLabel: listPriceAccessibilityLabel,
      originalPriceLabel: originalPriceLabel,
      message: priceMessage,
      priceLabel: priceLabel,
      salePrice: salePrice,
      salePriceAccessibilityLabel: salePriceAccessibilityLabel,
      variant: 'default'
    },
    productVariant: {
      externalMedia: externalSwatchImage,
      swatchImage: swatchImage,
      variantTypeLabel: variantTypeLabel,
      variantTypeDescription: variantTypeDescription
    },
    ratings: {
      maxRating: 5,
      rating: rating,
      reviewsCount: reviewCount,
      reviewAccessibilityLabel: reviewAccessibilityLabel
    },
    screenReaderText: screenReaderText,
    secondValueTag: additionalOffersText,
    tag: {
      message: tagMessage,
      style: 'default',
      variant: 'default'
    },
    tagsBottom: tagsBottom,
    tagsTop: tagsTop,
    title: {
      tagName: htmlTag,
      text: newTitle,
      textStyle: 'label'
    },
    valueTag: promoText,
    isLoading: isLoading,
    loaderVariant: "default"
  })));
};

/**
 * Function to get the getTitle for the card
 * @method
 * @param {Object} event
 * @returns { String } // string for the new Product Name
 */
exports.ProductCardHorizontal = ProductCardHorizontal;
const getTitle = data => {
  const {
    brandName,
    productName,
    style
  } = data;
  let newProductName;
  switch (style) {
    case 'list':
      newProductName = productName;
      break;
    case 'rail':
      newProductName = brandName + ' ' + productName;
      break;
  }
  return newProductName;
};

/**
 * Function to get the getBrandName for the card
 * @method
 * @param {Object} event
 * @returns { String } // string for the new Brand Name
 */
exports.getTitle = getTitle;
const getBrandName = data => {
  const {
    brandName,
    style
  } = data;
  let newBrandName;
  switch (style) {
    case 'list':
      newBrandName = brandName;
      break;
    case 'rail':
      newBrandName = undefined;
      break;
  }
  return newBrandName;
};

/**
 * Property type definitions
 * @typedef ProductCardHorizontalProps
 * @type {object}
 * @property {string} additionalOffersText - second valueTag text
 * @property {string} brandName - the brandName for the product card
 * @property {object} externalActionElement - fully clickable card action from web-site
 * @property {object} externalFooterActionElement - addToBagAction coming from web-site
 * @property {object} externalMediaElement - the image coming from web-site
 * @property {object} externalSwatchImage - external swatch image
 * @property {boolean} fullyClickableParent - boolean if card can be fully clickable
 * @property {string} kitPrice - kit price of the product
 * @property {string} kitPriceAccessibilityLabel - Sets the kit price accessibility label
 * @property {string} listPrice - list price of the product
 * @property {string} listPriceAccessibilityLabel - Sets the list price accessibility label
 * @property {string} originalPriceLabel - original price label in web-site
 * @property {boolean} priceDisabled - sets the disabled state for the price
 * @property {string} priceLabel - price label of the product
 * @property {string} priceMessage - message to display when there is no price
 * @property {string} productName - name of the product
 * @property {string} promoText - This is the promo text for the product
 * @property {number} rating - This is the rating of the product
 * @property {string} reviewAccessibilityLabel - This is the reviewAccessibilityLabel for the product
 * @property {number} reviewCount - This is the reviewCount for the product
 * @property {string} salePrice - sale price of the product
 * @property {string} salePriceAccessibilityLabel - Sets the sale price accessibility label
 * @property {string} style - the card style (rail or list)
 * @property {object} swatchImage - palette swatch image
 * @property {string} tagMessage - message text for the tag
 * @property {array} tagsBottom - Allows passing an array of tag objects to display in the card body
 * @property {array} tagsTop - Allows passing an array of tag objects to display in the card header
 * @property {string} variantTypeDescription - variant description coming from web-site (called variantLabel in web-site)
 * @property {string} variantTypeLabel - variant label coming from web-site
 * @property {boolean} isLoading - Sets the loading state of the product card
 * @property {string} loaderHeightSm - Accepts the height of the loader for small viewport( e.g. "32.2rem" )
 * @property {string} loaderHeightMd - Accepts the height of the loader for medium viewport( e.g. "32.2rem" )
 * @property {string} loaderHeightLg - Accepts the height of the loader for large viewport( e.g. "32.2rem" )
 * @property {string} loaderHeightXl - Accepts the height of the loader for xLarge viewport( e.g. "32.2rem" )
 */
exports.getBrandName = getBrandName;
const propTypes = exports.propTypes = {
  /**
   * second valueTag text
   */
  additionalOffersText: _propTypes.default.string,
  /**
   * brandName for the product card
   */
  brandName: _propTypes.default.string,
  /**
   * fully clickable card action from web-site
   */
  externalActionElement: _propTypes.default.object,
  /**
   * addToBagAction coming from web-site
   */
  externalFooterActionElement: _propTypes.default.object,
  /**
   * the externalMediaElement for the ProductCardDefault
   */
  externalMediaElement: _propTypes.default.object,
  /**
   * the external swatch image
   */
  externalSwatchImage: _propTypes.default.object,
  /**
   * boolean if card can be fully clickable
   */
  fullyClickableParent: _propTypes.default.bool,
  /**
   * kit price of the product
   */
  kitPrice: _propTypes.default.string,
  /**
   * Sets the kit price accessibility label
   */
  kitPriceAccessibilityLabel: _propTypes.default.string,
  /**
   * list price of the product
   */
  listPrice: _propTypes.default.string,
  /**
   * Sets the list price accessibility label
   */
  listPriceAccessibilityLabel: _propTypes.default.string,
  /**
   * Sets the original price label in web-site
   */
  originalPriceLabel: _propTypes.default.string,
  /**
   * Sets the disabled state of the price
   */
  priceDisabled: _propTypes.default.bool,
  /**
   * price label of the product
   */
  priceLabel: _propTypes.default.string,
  /**
   * Sets the message to display when there is no price
   */
  priceMessage: _propTypes.default.string,
  /**
   * productName for the product card
   */
  productName: _propTypes.default.string,
  /**
   * promo text for the product
   */
  promoText: _propTypes.default.string,
  /**
   * rating of the product
   */
  rating: _propTypes.default.number,
  /**
   * the reviewAccessibilityLabel for the product
   */
  reviewAccessibilityLabel: _propTypes.default.string,
  /**
   * the reviewCount for the product
   */
  reviewCount: _propTypes.default.number,
  /**
   * sale price of the product
   */
  salePrice: _propTypes.default.string,
  /**
   * Sets the sale price accessibility label
   */
  salePriceAccessibilityLabel: _propTypes.default.string,
  /**
   * sale price of the product
   */
  style: _propTypes.default.oneOf(['list', 'rail']),
  /**
   * palette swatch image
   */
  swatchImage: _propTypes.default.object,
  /**
   * message text for the tag
   */
  tagMessage: _propTypes.default.string,
  /**
   * Allows passing an array of tag objects to the ProductCardBody
   * See tag component for more detail ../Tag/Tag.jsx
   */
  tagsBottom: _propTypes.default.arrayOf(_propTypes.default.object),
  /**
   * Allows passing an array of tag objects to the ProductCardHeader
   * See tag component for more detail ../Tag/Tag.jsx
   */
  tagsTop: _propTypes.default.arrayOf(_propTypes.default.object),
  /**
   * variant description coming from web-site (called variantLabel in web-site)
   */
  variantTypeDescription: _propTypes.default.string,
  /**
   * variant label coming from web-site
   */
  variantTypeLabel: _propTypes.default.string,
  /**
   * Sets the loading state of the product card
   */
  isLoading: _propTypes.default.bool,
  /**
   * Accepts the height of the loader for small viewport.
   * Expect a CSS length string (for example: **"32.2rem"**)
   */
  loaderHeightSm: _propTypes.default.string,
  /**
   * Accepts the height of the loader for medium viewport.
   * Expect a CSS length string (for example: **"32.2rem"**)
   */
  loaderHeightMd: _propTypes.default.string,
  /**
   * Accepts the height of the loader for large viewport.
   * Expect a CSS length string (for example: **"32.2rem"**)
   */
  loaderHeightLg: _propTypes.default.string,
  /**
   * Accepts the height of the loader for Xlarge viewport.
   * Expect a CSS length string (for example: **"32.2rem"**)
   */
  loaderHeightXl: _propTypes.default.string
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} style='rail' - the card style (rail or list)
 * @property {boolean} isLoading = false - sets default loading state of the card to false
 */

const defaultProps = exports.defaultProps = {
  style: 'rail',
  isLoading: false
};
ProductCardHorizontal.propTypes = propTypes;
var _default = exports.default = ProductCardHorizontal;